export const getSamlJwtFromDeepLink = (url) => {
    const splitUrl = url.split('?token=');
    return splitUrl[1];
};
